import { InfoCircle } from "@untitledui/icons";

export const SEGMENT_COLORS_INVITED_COLLABORATORS = [
  "#36bffa", // Emerging Stars — blue-light-400
  "#f38744", // VIP — orange-400
  "#faa7e0", // Artist — pink-300
  "#a78bfa", // TODO: review with nick or Lara the remaining colors
  "#34d399", // TODO: review with nick or Lara the remaining colors
  "#fb7185", // TODO: review with nick or Lara the remaining colors
];

export type Segment = {
  label: string;
  count: number;
};

// Generic: from a list of category labels (one per item), build ordered, deduped, zero-count-free
// segments. Labels not in `fixedTrailingOrder` come first (in first-seen order); the rest follow
// in the exact order given.
export function buildSegments(labels: string[], fixedTrailingOrder: string[] = []): Segment[] {
  const counts = new Map<string, number>();
  for (const label of labels) {
    counts.set(label, (counts.get(label) ?? 0) + 1);
  }

  const leading = Array.from(counts.keys()).filter((label) => !fixedTrailingOrder.includes(label));
  return [...leading, ...fixedTrailingOrder]
    .filter((label) => counts.has(label))
    .map((label) => ({ label, count: counts.get(label) as number }));
}

// The color a given label would render as in the bar, based on its position in `segments` — same
// SEGMENT_COLORS_INVITED_COLLABORATORS[i % length] rule the bar itself uses below.
export function getCategoryColor(label: string, segments: Segment[]): string {
  const index = Math.max(
    segments.findIndex((segment) => segment.label === label),
    0,
  );
  return SEGMENT_COLORS_INVITED_COLLABORATORS[index % SEGMENT_COLORS_INVITED_COLLABORATORS.length];
}

type ProgressBarProps = {
  segments: Segment[];
};

export const ProgressBar = ({ segments }: ProgressBarProps) => {
  const total = segments.reduce((sum, seg) => sum + seg.count, 0);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-1.5">
        <span className="text-sm font-medium text-secondary">Distribution of creators</span>
        <InfoCircle className="w-3 h-3 text-quaternary shrink-0" />
      </div>
      <div className="flex gap-1 h-[33px]">
        {segments.map((seg, i) => {
          const pct = total > 0 ? (seg.count / total) * 100 : 0;
          const color = SEGMENT_COLORS_INVITED_COLLABORATORS[i % SEGMENT_COLORS_INVITED_COLLABORATORS.length];
          return <div key={seg.label} className="rounded-[4px]" style={{ width: `${pct}%`, backgroundColor: color }} />;
        })}
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-1">
        {segments.map((seg, i) => {
          const color = SEGMENT_COLORS_INVITED_COLLABORATORS[i % SEGMENT_COLORS_INVITED_COLLABORATORS.length];
          return (
            <div key={seg.label} className="flex items-center gap-1.5">
              <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: color }} />
              <span className="text-sm text-tertiary">
                {seg.label} ({seg.count})
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
